/**
 * Konfigurasi terpusat TanStack Query.
 * SATU-SATUNYA sumber nilai staleTime/gcTime/retry/refetch.
 * Guardrail ESLint menolak nilai ini di-hardcode ulang di komponen.
 */

/** Selaras dengan DEFAULT_TTL lama di api-client.ts (60 detik). */
export const STALE_TIME = 60_000;
export const GC_TIME = 5 * 60_000;

/** Default konservatif untuk semua query (mulai aman, naikkan bertahap). */
export const DEFAULT_QUERY_OPTIONS = {
  staleTime: STALE_TIME,
  gcTime: GC_TIME,
  retry: 1,
  refetchOnWindowFocus: false,
} as const;

/** Interval polling default untuk status yang belum final (mis. pembayaran). */
export const POLL_INTERVAL = 5_000;
